import base64 from 'base-64'
import { mapValues, omitBy } from 'lodash-es'
import utf8 from 'utf8'

import type { SATInvitationParams } from './types'

// Given InvitationParams, convert that to a query string and then to an encoded base64 string
// Example: { cwid: 100, name: Elysa } -> cwid=100&name=Elysa -> Y3dpZD0xMDAmbmFtZT1FbHlzYQ
export default function encodeInvitationParams(params: SATInvitationParams): string {
  const nonUndefinedParams = omitBy(params, value => value == null)
  const stringParams = mapValues(nonUndefinedParams, value => value.toString())

  const urlSearchParams = new URLSearchParams(stringParams)

  const bytes = utf8.encode(urlSearchParams.toString())
  const encodedText = base64.encode(bytes)

  return encodedText
}
